export default {
  DESKTOP: 1200,
  PHONE: 767,
  TABLET_HORIZONTAL: 992,
  TABLET_VERTICAL: 768,
};
